import { ExternalLink } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button, PopoverContent } from '@bliks-io/ui';

interface ComingSoonPopoverProps {
  route: string;
  title: string;
}

export function ComingSoonPopover({ route, title }: ComingSoonPopoverProps) {
  const { t } = useTranslation();

  const renderComingSoonContent = () => {
    switch (route) {
      case '/survey':
        return (
          <p className="mt-1 text-xs font-normal leading-tight text-black">
            {t('common.Sidebar.needSpecificDetail')}
          </p>
        );

      case '/analytics':
        return (
          <p className="mt-1 text-xs font-normal leading-tight text-black">
            {t('common.Sidebar.SeeWhichPeople')}
          </p>
        );

      case '/active-monitoring':
        return (
          <div className="mt-1 space-y-1 text-xs font-normal leading-tight text-black">
            <p>{t('common.Sidebar.ensureContinuity')}</p>
            <p>{t('common.Sidebar.AreTheRelevant')}</p>
            <p>{t('common.Sidebar.areThereBottleneck')}</p>
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <PopoverContent side="right" align="start" className="w-64 p-3">
      <div className="flex flex-col items-center justify-center text-center">
        <h3 className="mb-2 text-xs font-normal">{t(title)}</h3>

        <img
          className="w-full h-auto max-w-[120px]"
          src="/assets/images/coming-soon.png"
          alt="Coming Soon"
        />

        <div className="mt-2 inline-flex items-center rounded-sm border border-danger-line bg-danger-surface px-1.5 py-0.5 text-xs font-normal text-danger select-none">
          {t('common.Sidebar.ComingSoon')}
        </div>

        <div className="max-w-[200px] text-left text-xs font-normal">
          {renderComingSoonContent()}
        </div>

        <Button
          variant="outline"
          size="small"
          className="gap-1 px-2 mt-3 text-xs font-normal h-7"
          onClick={() => window.open('https://bliks.io/roadmap', '_blank')}
        >
          {t('common.Sidebar.LearnMore')}
          <ExternalLink className="w-3 h-3 text-fg-subtle" />
        </Button>
      </div>
    </PopoverContent>
  );
}
